import { useFetcherData } from "v2/hooks/useFetcherData";

import { FetcherKeys } from "routes/dataroutes/Fetchers";
import { Issue, StatuspageIssues } from "routes/dataroutes/IssuesData";


export type AllIssuesLoaderDataType = { issues: Issue[] | null };

export function useAllIssues() {
  const { value, fetcher } = useFetcherData<AllIssuesLoaderDataType>({
    fetcherKey: FetcherKeys.ALL_ISSUES,
    fetcherHref: "/issues-data/all",
  });

  return {
    issues: value?.issues,
    issuesFetcher: fetcher
  };
}


export type StatusPageIssuesLoaderDataType = { issues: StatuspageIssues | null };

export function useStatuspageIssues() {
  const { value, fetcher } = useFetcherData<StatusPageIssuesLoaderDataType>({
    fetcherKey: FetcherKeys.STATUSPAGE_ISSUES,
    fetcherHref: "/issues-data/statuspage",
  });

  return {
    issues: value?.issues,
    issuesFetcher: fetcher
  };
}
